import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, GridLegacy as Grid, TextField, Typography } from '@mui/material'
import { Controller, useForm } from "react-hook-form";
import { AxiosInstance, FormActions } from "../../utils/constants";
import * as yup from "yup";
import { AutoCompleteInputWithLabel, InputWithLabel, SelectInputWithLabel } from "./custom-imputs";
import { useEffect, useState } from "react";


const validatorShema = yup.object({
   nombres:yup.string().required(),
   apellidos:yup.string().required(),
   cod_tipo_identificacion:yup.string().required(),
   numero_documento:yup.string().required(),
   email:yup.string().notRequired().optional().nullable(),
   celular:yup.number().required(),
   ind_estado:yup.string().required()
});

export const FormConductores = ({
    isOpened,
    onSendData,
    vehiculo={},
    mode,
    onCloseVehicle,
    parent_cod
    
})=>{

    const { control, register, handleSubmit, formState: { errors },setValue } = useForm({
        resolver: yupResolver(validatorShema),
        defaultValues: vehiculo
    });
    const [tiposVehiculos,setTiposVehiculos] = useState([]); 
    const [tiposIdentificacion,setTiposIdentificacion] = useState([]); 
    const [vehiculosOptions,setVehiculosOptions] = useState([]);

    
    useEffect( ()=>{
        Object.keys( vehiculo ).forEach( key=>{
            setValue(key,vehiculo[key]);
        });

        if(mode === FormActions.AGREGAR ){
            setValue("ind_estado","EN REVISION");
        }

    },[vehiculo] );

    useEffect(()=>{

       
        loadInitData();

       

    },[]);

    const loadInitData = async()=>{

/*        AxiosInstance.post("maestros/obtener-tipos-vehiculos",{
            rows_per_page:100,
            page_number:1
        }).then(({data})=>{
            setTiposVehiculos(data?.value?.data?.map(item=>({value:item.cod,label:item.descripcion})));
        }); */

        AxiosInstance.post("logistico/obtener-tipos-identificacion",{
            rows_per_page:100,
            page_number:1
        }).then(({data})=>{
            setTiposIdentificacion(data?.value);
        });
    }

    const onSubmitForm = (data)=>{
        
        if (  mode !== FormActions.AGREGAR){
            data.cod = vehiculo.cod;
           
        }
       data.cod_empresa_transporte = parent_cod;
        
        onSendData(data);
    }

    const onSearchVehiculo = (e,value)=>{
        console.log({e,value});
       if (value.length > 1 ){

        AxiosInstance.post("logistico/filtrar-vehiculos",{
            filter_search:value,
            cod_empresa:parent_cod
        }).then(({data})=>{

            setVehiculosOptions(data?.value.map((item)=>({
                label:`${item.placa}-${item.tipo_vehiculo}`,
                value:item.cod
            })));

        }).catch(err=>{

        }).finally(()=>{

        });
       }


    }

    return (
        <Dialog
        open={isOpened}
        >
            <DialogTitle>{mode === FormActions.AGREGAR?'Creacion':'Edicion'} de conductores</DialogTitle>
            <DialogContent>

                <form onSubmit={handleSubmit(onSubmitForm)} >
                <Grid container spacing={1} >
                <Grid item xs={12} sm={12} md={12} >
                    <Typography>
                        Datos basicos
                    </Typography>
                </Grid>
                    
                    <Grid item xs={6} sm={6} md={6} >

                        <Controller
                        control={control}
                        name="nombres"
                        render={({field})=><InputWithLabel size='small' label="Nombres"  errorMessage={errors?.[field.name]?.message}  {...field} />}
                        />

                    </Grid>
                    <Grid item xs={6} sm={6} md={6} >

                        <Controller
                            control={control}
                            name="apellidos"
                            render={({field})=><InputWithLabel size='small' label="Apellidos"  errorMessage={errors?.[field.name]?.message}  {...field} />}
                        />

                    </Grid>
                    <Grid item xs={6} sm={6} md={6} >
                            <Controller
                                control={control}
                                name="cod_tipo_identificacion"
                                render={({field})=><SelectInputWithLabel size='small' items={tiposIdentificacion} label="Tipo de identificacion"  errorMessage={errors?.[field.name]?.message}  {...field} 
                            />}
                            />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} >

                        <Controller
                            control={control}
                            name="numero_documento"
                            render={({field})=><InputWithLabel type="number" size='small' label="Numero de identificacion"  errorMessage={errors?.[field.name]?.message}  {...field} />}
                        />

                    </Grid>
                    <Grid item xs={6} sm={6} md={6} >

                        <Controller
                            control={control}
                            name="email"
                            render={({field})=><InputWithLabel type="email" size='small' label="Correo"  errorMessage={errors?.[field.name]?.message}  {...field} />}
                        />

                    </Grid>
                    <Grid item xs={6} sm={6} md={6} >

                        <Controller
                            control={control}
                            name="celular"
                            render={({field})=><InputWithLabel type="phone" size='small' label="Celular"  errorMessage={errors?.[field.name]?.message}  {...field} />}
                        />

                    </Grid>
                 {/*    <Grid item xs={6} sm={6} md={6} >

                        <Controller
                            control={control}
                            name="vehiculo"
                            render={({field})=><AutoCompleteInputWithLabel 
                            type="email" 
                            size='small' 
                            fullWidth
                            label="Vehiculo"  
                            options={vehiculosOptions || []}
                            noOptionsText="Lista vacia"
                            errorMessage={errors?.[field.name]?.message}  {...field} 
                            onInputChange={onSearchVehiculo}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            filterOptions={(x) => x}
                            {...field}
                            
                            />}
                           
                        />

                    </Grid> */}
                    <Grid item xs={6} sm={6} md={6} >
                            <Controller
                                control={control}
                                name="ind_estado"
                                render={({field})=><SelectInputWithLabel
                                disabled={mode === FormActions.AGREGAR}
                                size='small' items={[
                                    {
                                        label:"HABILITADO",
                                        value:"HABILITADO"
                                    },
                                    {
                                        label:"DESHABILITADO",
                                        value:"DESHABILITADO"
                                    },
                                    {
                                        label:"EN REVISION",
                                        value:"EN REVISION"
                                    },
                                ]} label="Estado del vehiculo"  errorMessage={errors?.[field.name]?.message}  {...field} 
                            />}
                            />
                    </Grid>
                                        
                    
                  
                                    
                </Grid>
                <DialogActions>
                <Button onClick={onCloseVehicle} type="button" size="small" variant="contained" color="secondary" >Cerrar</Button>
                    <Button type="submit" size="small" variant="contained" color="primary" >Guardar</Button>
            </DialogActions>
                </form>
              
                
              
            </DialogContent>
         
        </Dialog>
    )

}